import { gql, TypedDocumentNode } from '@apollo/client';

import { IGetPlansQueryGraphQLResponse, IGetPlansQueryVariables } from './useGetPlans.interfaces';

const GET_PLANS_QUERY = gql`
  query getPlans($currency: ECurrency, $product: EProduct!) {
    plans {
      getPlans: getAll(product: $product) {
        id
        productId
        active
        product {
          product
        }
        description
        name
        price(currency: $currency)
        stripePlanId
        sort
        createdAtUtc
        value
      }
    }
  }
` as TypedDocumentNode<IGetPlansQueryGraphQLResponse, IGetPlansQueryVariables>;

export { GET_PLANS_QUERY };
